import { EMPTY, Observable } from 'rxjs';

import { CommonService } from './../common/common.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from 'src/app/components/loader/loader.service';
import { MESSAGES } from 'src/app/constants/messages.constants';
import { ToastService } from './../../components/toast-notification/toast.service';
import { environment } from 'src/environments/environment';

// Observable < Api.Response < T >>










@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private http: HttpClient,
    private $loaderService: LoaderService,
    private $commonService: CommonService,
    private $toast: ToastService

  ) {
    // this.apiUrl = environment.apiBaseUrl;
  }

  private isOwnApi(url: string): boolean {
    // Treat relative URLs as own API; absolute URLs must match configured API base
    if (!url) { return true; }
    const isAbsolute = /^https?:\/\//i.test(url);
    if (!isAbsolute) { return true; }
    // Allow only our backend base URL to carry credentials
    return url.startsWith(environment.apiBaseUrl);
  }


  // post<T>(url, data?, loader = true): Observable<Common.ApiResponse<T>> {
  //     if (loader) {
  //         this._loaderService.loader.next(loader);
  //     }
  //     return this.http.post<Common.ApiResponse<T>>(this.apiUrl + url, data);
  // }


  put<T>(url, data, loader = true): Observable<Api.Response<T>> {
    if (navigator.onLine) {
      const trimData = this.$commonService.trim(data);
      if (loader) {
        this.$loaderService.show()
      }
      return this.http.put<Api.Response<T>>(url, trimData, { withCredentials: this.isOwnApi(url) });
    } else {
      this.$toast.error(MESSAGES.OFFLINE);
      this.$loaderService.hide();
      return EMPTY;
    }
  }


  post<T>(url, data?, query?, loader = true): Observable<Api.Response<T>> {
    let trimData;
    if (navigator.onLine) {
      if (data) {
        trimData = this.$commonService.trim(data);
      }

      if (loader) {
        this.$loaderService.show();
      }
      if (query) {
        return this.http.post<Api.Response<T>>(url, trimData, { params: query, withCredentials: this.isOwnApi(url) });
      }
      return this.http.post<Api.Response<T>>(url, trimData, { withCredentials: this.isOwnApi(url) });
    } else {
      this.$toast.error(MESSAGES.OFFLINE);
      this.$loaderService.hide();
      return EMPTY;
    }

  }

  patch<T>(url, data?, query?, loader = true): Observable<Api.Response<T>> {
    if (navigator.onLine) {
      let trimData;
      if (data) {
        trimData = this.$commonService.trim(data);


        if (loader) {
          this.$loaderService.show();
        }
        if (query) {
          return this.http.patch<Api.Response<T>>(url, trimData, { params: query, withCredentials: this.isOwnApi(url) });
        }
        return this.http.patch<Api.Response<T>>(url, trimData, { withCredentials: this.isOwnApi(url) });
      } else {
        this.$toast.error(MESSAGES.OFFLINE);
        this.$loaderService.hide();
        return EMPTY;
      }

    }

  }

  get<T>(url, httpParams?: any, loader = true): Observable<any> {
    if (navigator.onLine) {
      if (loader) {

      }
      for (let item in httpParams) {
        if (httpParams[item] === '' || httpParams[item] === undefined || httpParams[item] === null) {
          delete httpParams[item];
        }
      }
      const options: any = { withCredentials: this.isOwnApi(url) };
      if (httpParams) {
        options.params = httpParams;
      }
      return this.http.get(url, options);
    } else {
      this.$toast.error(MESSAGES.OFFLINE);
      this.$loaderService.hide();
      return EMPTY;
    }

  }
  delete(url, httpParams?, loader = true) {
    if (navigator.onLine) {
      if (loader) {
        this.$loaderService.show();
      }
      for (let item in httpParams) {
        if (httpParams[item] === '' || httpParams[item] === undefined || httpParams[item] === null) {
          delete httpParams[item];
        }
      }
      const options: any = { withCredentials: this.isOwnApi(url) };
      if (httpParams) {
        options.params = httpParams;
      }

      return this.http.delete<Api.Response<any>>(url, options);
    } else {
      this.$toast.error(MESSAGES.OFFLINE);
      this.$loaderService.hide();
      return EMPTY;
    }

  }

}
